import React, { useEffect } from "react";
import "./App.css";
import { currentAuth } from "./redux/firebaseState/selectors";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "./redux/type";
import { LoginComponent } from "./components/pages/login";
import { LayoutComponent } from "./components/navigationLayout/Layout";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import firebase from "./firebase/config";
import {
  getUserByIdAction,
  setLoadingAction,
  setNeedVerification,
} from "./redux/firebaseState/api";
import Loader from "./components/UI/Loader";
import NewsLetter from "./components/pages/newsLetter";
import UsersPage from "./components/pages/users";
import PurchaseHistoryPage from "./components/pages/purchaseHistory";
import LeaderboardPage from "./components/pages/leaderboard";
import AddBanner from "./components/pages/banner";
import PrivacyPolicy from "./components/pages/privacyPolicy";
import DeleteAccount from "./components/pages/deleteAccount";
import WinnerAnnouncement from "./components/pages/winnerAnnouncement";
import ManualNotification from "./components/pages/manualNotification";
import EditPrivacyPolicy from "./components/pages/editPrivacyPolicy";
import TermsAndConditions from "./components/pages/termsAndConditions";
import ChangePassword from "./components/pages/changePassword";
import ForgotPassword from "./components/pages/forgotPassword";

const router = createBrowserRouter([
  {
    path: "AfterLogin",
    element: <LayoutComponent />,
    //errorElement: <ErrorPage />,
    children: [
      {
        path: "newsletter",
        element: <NewsLetter />,
      },
      {
        path: "banner",
        element: <AddBanner />,
      },
      {
        path: "users",
        element: <UsersPage />,
      },
      {
        path: "leaderboard",
        element: <LeaderboardPage />,
      },
      {
        path: "winnerannouncement",
        element: <WinnerAnnouncement />,
      },
      {
        path: "manualnotification",
        element: <ManualNotification />,
      },
      {
        path: "editprivacypolicy",
        element: <EditPrivacyPolicy />,
      },
      {
        path: "changepassword",
        element: <ChangePassword/>,
      },
      // {
      //   path: "purchasehistory",
      //   element: <PurchaseHistoryPage />,
      // },
    ],
  },
  {
    path: "privacypolicy",
    element: <PrivacyPolicy />, 
  },
  {
    path: "deleteaccount",
    element: <DeleteAccount />, 
  },
  {
    path: "termsandconditions",
    element: <TermsAndConditions />, 
  },
  {
    path: "forgotpassword",
    element: <ForgotPassword/>,
  },
  {
    path: "*",
    element: <LoginComponent />,
  },
]);
function App() {
  const dispatch = useDispatch();
  const { loading } = useSelector<RootState, RootState["auth"]>(currentAuth);

  // Check if user exists
  useEffect(() => {
    dispatch(setLoadingAction(true));
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        dispatch(setLoadingAction(true));
        dispatch(getUserByIdAction(user.uid));
        if (!user.emailVerified) {
          dispatch(setNeedVerification());
        }
      }
      dispatch(setLoadingAction(false));
    });

    return () => {
      unsubscribe();
    };
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }
  return <RouterProvider router={router} />;
}

export default App;
